import React, { FC, ReactNode, useRef } from 'react';
import styled from '@emotion/styled';

export interface TooltipProps {
  x: number;
  y: number;
  fixed?: boolean;
  message: ReactNode;
  visible: boolean;
}
const TooltipWrapper = styled.div<{ fixed?: boolean }>`
  position: ${p => (p.fixed ? 'fixed' : 'absolute')};
  pointer-events: none;
  top: -12px;
  transition: transform 50ms ease-in-out 0s, opacity 0ms linear 50ms;
  left: 0;
  min-width: 80px;
  z-index: 1000;
  font-size: 12px;
  line-height: 25px;
  font-family: sans-serif;
  padding: 6px;
  color: #000;
  background-color: #fff;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  word-wrap: normal;
  border-radius: 6px;
  word-break: keep-all;
  /* Tooltip Arrow is basically a div box rotated 45 degrees */
  &:before {
    content: '';
    width: 12px;
    height: 12px;
    left: 50%;
    z-index: 0;
    transform: translate(-50%, -50%) rotate(45deg);
    position: absolute;
    pointer-events: none;
    display: flex;
    background: #fff;
    top: 100%;
  }
`;
const ChartTooltip: FC<TooltipProps> = p => {
  const ref = useRef<HTMLDivElement>(null);
  let x = p.x;
  let y = p.y;
  // tooltip mode for ie11
  if (typeof window !== 'undefined' && window.document['documentMode']) {
    if (ref.current) {
      x = p.x - ref.current.clientWidth / 2;
      y = p.y - ref.current.clientHeight;
    }
    return (
      <TooltipWrapper
        fixed={p.fixed}
        ref={ref}
        style={{
          transform: `translate(${x}px, ${y}px)`,
          opacity: p.visible ? 1 : 0,
        }}
      >
        {p.message}
      </TooltipWrapper>
    );
  } else {
    return (
      <TooltipWrapper
        fixed={p.fixed}
        style={{
          transform: `translate(calc(${p.x}px - 50%), calc(${p.y}px - 100%))`,
          opacity: p.visible ? 1 : 0,
        }}
      >
        {p.message}
      </TooltipWrapper>
    );
  }
};

export { ChartTooltip };
